module.exports = __webpack_public_path__ + "static/img/materialsInfo1t3.ba7a7ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo1t3.png
// module id = VCWV
// module chunks = 2